var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.001C13.9997 13.5314 13.7888 14.04 13.4135 14.4149C13.0382 14.7898 12.5294 15.0003 11.999 15C11.4686 14.9997 10.96 14.7888 10.5851 14.4135C10.2102 14.0382 9.99974 13.5294 10 12.999C10.0003 12.4686 10.2112 11.96 10.5865 11.5851C10.9618 11.2102 11.4706 10.9997 12.001 11C12.5314 11.0003 13.04 11.2112 13.4149 11.5865C13.7898 11.9618 14.0003 12.4706 14 13.001ZM14.06 16.481H10.06V29.001H14.06V16.481ZM20.38 16.481H16.4V29.001H20.34V22.431C20.34 18.771 25.11 18.431 25.11 22.431V29.001H29.06V21.071C29.06 14.901 22 15.131 20.34 18.161L20.38 16.481Z",
    fill: "#0C1C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLinkedin);
export default __webpack_public_path__ + "static/media/ImgLinkedin.62e38aec25a13650f5e5a2ec0a4649f5.svg";
export { ForwardRef as ReactComponent };